import "core-js/modules/es.array.index-of";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.match";
import "core-js/modules/es.string.starts-with";
export var getHrefType = function getHrefType(href) {
  if (!href) {
    return 'empty';
  }

  if (href.startsWith('mailto:')) {
    return 'mailto';
  }

  var hasScheme = !!href.match(/^\w+:\/\//);
  return href.indexOf(window.location.origin) === 0 || !hasScheme ? 'internal' : 'external';
};

var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

export var canNavigate = function canNavigate(event, _ref) {
  var forceRefresh = _ref.forceRefresh,
      download = _ref.download,
      href = _ref.href,
      target = _ref.target;
  return !forceRefresh && getHrefType(href) === 'internal' && !download && ( // event.button may be undefined in enzyme simulates
  event.button === undefined || event.button === 0) && target !== '_blank' && !isModifiedEvent(event);
};